export const mainColor = '#ee2f79';
export const greyColor = '#8B8B8B';
export const bespokeMainColor = '#4C2480';
